import styles from "./internalcards.module.scss";
import { Link } from "react-router-dom";
import { formatFullName } from "src/utils";
import { Card } from "../cards/cardSlice";
import { cardStatusColors } from "src/variable/randomColor";
import { ShortIdChip } from "src/components/UI/shortIdChip";
import { cellClasses, DateStack, EmptyCell, MemberCell } from "src/components/UI/transactionCells";

const columns = [
  {
    title: "Id",
    dataIndex: "id",
    key: "id"
  },
  {
    title: "Card Holder",
    dataIndex: "cardHolder",
    key: "cardHolder",
    render: (_text: string, card: Card) => <div>{card?.cardHolderName ? card?.cardHolderName : "--"}</div>
  },
  {
    title: "Card No.",
    dataIndex: "cardNumber",
    key: "cardNumber",
    render: (_text: string, card: Card) => <div>{card.cardNumber ? card.cardNumber : "--"}</div>
  },
  {
    title: "User",
    dataIndex: "id",
    key: "User",
    render: (_id: string, data: Card) => (
      <MemberCell
        fullName={formatFullName(data?.user?.firstName, data?.user?.lastName)}
        email={data?.user?.email}
        userId={data?.user?.id}
      />
    )
  },
  {
    title: "Site/Cost Centre",
    dataIndex: "object_id",
    key: "group",
    render: (object_id: string, data: Card) => {
      if (data?.object_type === "GROUP" && object_id) {
        return (
          <Link to={`/groups/${object_id}`} className={styles.tableMember}>
            {object_id}
          </Link>
        );
      }
      return <div>---</div>;
    }
  },
  {
    title: "Client Id",
    dataIndex: "clientId",
    key: "clientId"
  },
  {
    title: "Organisation",
    dataIndex: "organisationId",
    key: "organisationId",
    render: (organisationId: string, card: Card) => {
      const name = card?.organisation?.name;

      if (!organisationId || !name) return <EmptyCell />;

      return (
        <div className={cellClasses.tableWallet}>
          <Link
            to={`/account/${organisationId}`}
            className={cellClasses.tableWalletName}
            aria-label={`View details for organisation ${name}`}
            title={name}
          >
            {name}
          </Link>
          <ShortIdChip id={organisationId} copiedLabel="Organisation ID Copied!" variant="ghost" />
        </div>
      );
    }
  },
  {
    title: "Order Id",
    dataIndex: "orderId",
    key: "orderId"
  },
  {
    title: "Status",
    dataIndex: "cardStatus",
    key: "cardStatus",
    render: (cardStatus: string) => (
      <div className={styles.tableCardStatus}>
        <div
          className={styles.tableCardStatusColor}
          style={{
            backgroundColor: `${cardStatusColors[cardStatus]}0d`,
            borderColor: `${cardStatusColors[cardStatus]}73`,
            color: `${cardStatusColors[cardStatus]}FF`
          }}
        >
          {cardStatus.slice(0, 1).toUpperCase() + cardStatus.slice(1).toLowerCase()}
        </div>
      </div>
    )
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render: (created_at: string) => <DateStack value={created_at} />
  },
  {
    title: "Access Type",
    dataIndex: "accessType",
    key: "accessType"
  }
];

export default columns;
